import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateBatchApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateBatch = createAsyncThunk('updateBatch', async (payload) => {
  return await updateBatchApi(payload);
});

const updateBatchSlice = createSlice({
  name: 'updateBatch', // Unique Name
  initialState,
  reducers: {
    updateBatchReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateBatch.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateBatch.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateBatch.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateBatchReset } = updateBatchSlice.actions;

export default updateBatchSlice.reducer;
